import { useEffect, useState } from 'react';
import { readAppInjectedAuth, } from '@/utils/appWebViewBridge';
export const SCC_APP_AUTH_READY_EVENT = 'scc-app-auth-ready';
export function useAppInjectedAuth() {
    const [auth, setAuth] = useState(() => readAppInjectedAuth());
    useEffect(() => {
        if (typeof window === 'undefined')
            return;
        const handler = () => {
            setAuth(readAppInjectedAuth());
        };
        window.addEventListener(SCC_APP_AUTH_READY_EVENT, handler);
        return () => window.removeEventListener(SCC_APP_AUTH_READY_EVENT, handler);
    }, []);
    return auth;
}
